<template>
  <div class="tableStyle">
    <div>
      <div class="dataRight" style="background-color: #081831;">
        <div class="stateTable">
          <el-scrollbar>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane name="first"
                ><span slot="label"
                  ><i class="iconfont icon-shijianchuo"></i>{{$t('common.nearlyMonth')}}</span
                >
                <div v-if="'first' === activeName">
                  <MonthTime ref="monthTime"></MonthTime>
                </div>
              </el-tab-pane>
              <el-tab-pane name="second"
                ><span slot="label"
                  ><i class="iconfont icon-benyue"></i>{{$t('common.choseTime')}}</span
                >
                <div v-if="'second' === activeName">
                  <ChangeTime ref="changeTime"></ChangeTime>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckReportForm from "./CheckReportForm.js";
export default CheckReportForm;
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/Style.less";
/deep/.el-tabs {
  .el-tabs__header {
    margin: 0 16px 10px !important;
    .el-tabs__item {
      color: #85919d !important;
    }
    .el-tabs__item.is-active {
      color: #fff !important;
    }
  }
}
</style>
